import { useQuery } from '@tanstack/react-query';
import { AssetService } from '~/app/services/asset/asset.service';

/** Shared React Query key for GET /api/v1/assets/:assetId/summary (page + breadcrumb). */
export function assetSummaryQueryKey(assetId: string) {
  return ['assets', 'summary', assetId] as const;
}

export function useAssetSummary(organizationId: string, assetId: string) {
  const summaryQuery = useQuery({
    queryKey: assetSummaryQueryKey(assetId),
    queryFn: () => AssetService.findSummaryById(organizationId, assetId),
    enabled: !!assetId && !!organizationId,
  });

  return {
    summary: summaryQuery.data,
    isLoading: summaryQuery.isLoading,
    error: summaryQuery.error,
    refetch: summaryQuery.refetch,
  };
}
